import { render, staticRenderFns } from "./BindProductsView.vue?vue&type=template&id=69236b76"
import script from "./BindProductsView.vue?vue&type=script&lang=js"
export * from "./BindProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports